/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddCommentRequest } from '../model';
// @ts-ignore
import type { AssociateControlPolicy } from '../model';
// @ts-ignore
import type { AssociateControlTest } from '../model';
// @ts-ignore
import type { Comment } from '../model';
// @ts-ignore
import type { Component } from '../model';
// @ts-ignore
import type { Control } from '../model';
// @ts-ignore
import type { ControlExpandedPaginated } from '../model';
// @ts-ignore
import type { ControlPaginated } from '../model';
// @ts-ignore
import type { ControlStatus } from '../model';
// @ts-ignore
import type { ControlsSorting } from '../model';
// @ts-ignore
import type { EvidenceMetadata } from '../model';
// @ts-ignore
import type { Framework } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { Log } from '../model';
// @ts-ignore
import type { Policy } from '../model';
// @ts-ignore
import type { PolicyPaginated } from '../model';
// @ts-ignore
import type { PolicySorting } from '../model';
// @ts-ignore
import type { ProjectTestPaginated } from '../model';
// @ts-ignore
import type { ProjectTestSorting } from '../model';
// @ts-ignore
import type { ProjectTestType } from '../model';
// @ts-ignore
import type { Requirement } from '../model';
// @ts-ignore
import type { Tag } from '../model';
// @ts-ignore
import type { UpdateComponentsRequest } from '../model';
// @ts-ignore
import type { UpdateControlOwnershipRequest } from '../model';
// @ts-ignore
import type { UpdateControlStatusRequest } from '../model';
/**
 * ControlApi - axios parameter creator
 */
export const ControlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Associate a published policy with a control.
         * @summary Associate Control Policy
         * @param {string} controlId 
         * @param {AssociateControlPolicy} associateControlPolicy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateControlPolicy: async (controlId: string, associateControlPolicy: AssociateControlPolicy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('associateControlPolicy', 'controlId', controlId)
            // verify required parameter 'associateControlPolicy' is not null or undefined
            assertParamExists('associateControlPolicy', 'associateControlPolicy', associateControlPolicy)
            const localVarPath = `/controls/{control_id}/policies`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(associateControlPolicy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Attach a test — agent or metric — to a control.
         * @summary Associate Control Test
         * @param {string} controlId 
         * @param {AssociateControlTest} associateControlTest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateControlTest: async (controlId: string, associateControlTest: AssociateControlTest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('associateControlTest', 'controlId', controlId)
            // verify required parameter 'associateControlTest' is not null or undefined
            assertParamExists('associateControlTest', 'associateControlTest', associateControlTest)
            const localVarPath = `/controls/{control_id}/tests`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(associateControlTest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Controls Comments
         * @param {string} controlId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createControlsComments: async (controlId: string, addCommentRequest: AddCommentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('createControlsComments', 'controlId', controlId)
            // verify required parameter 'addCommentRequest' is not null or undefined
            assertParamExists('createControlsComments', 'addCommentRequest', addCommentRequest)
            const localVarPath = `/controls/{control_id}/comments`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Control
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControl: async (controlId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('getControl', 'controlId', controlId)
            const localVarPath = `/controls/{control_id}`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Control Comments
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlComments: async (controlId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('getControlComments', 'controlId', controlId)
            const localVarPath = `/controls/{control_id}/comments`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all components for a control.
         * @summary Get Control Components
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlComponents: async (controlId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('getControlComponents', 'controlId', controlId)
            const localVarPath = `/controls/{control_id}/components`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all evidence metadata for a control, with each document\'s processing state.
         * @summary Get Control Evidences
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlEvidences: async (controlId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('getControlEvidences', 'controlId', controlId)
            const localVarPath = `/controls/{control_id}/evidences`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Control Logs
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlLogs: async (controlId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('getControlLogs', 'controlId', controlId)
            const localVarPath = `/controls/{control_id}/logs`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get mapped frameworks for a control.
         * @summary Get Control Mapped Frameworks
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlMappedFrameworks: async (controlId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('getControlMappedFrameworks', 'controlId', controlId)
            const localVarPath = `/controls/{control_id}/mapped-frameworks`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get mapped requirements for a control.
         * @summary Get Control Mapped Requirements
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlMappedRequirements: async (controlId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('getControlMappedRequirements', 'controlId', controlId)
            const localVarPath = `/controls/{control_id}/mapped-requirements`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get policies associated with a control (paginated; sort/filter like GET /policies).
         * @summary Get Control Policies
         * @param {string} controlId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PolicySorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlPolicies: async (controlId: string, page?: number, size?: number, sortBy?: PolicySorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('getControlPolicies', 'controlId', controlId)
            const localVarPath = `/controls/{control_id}/policies`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (nameOrUniqueCode !== undefined) {
                localVarQueryParameter['name_or_unique_code'] = nameOrUniqueCode;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Control Tags
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlTags: async (controlId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('getControlTags', 'controlId', controlId)
            const localVarPath = `/controls/{control_id}/tags`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the tests attached to this control, agent and metric together.
         * @summary Get Control Tests
         * @param {string} controlId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ProjectTestSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {boolean} [exactMatch] 
         * @param {ProjectTestType | null} [testType] 
         * @param {string | null} [notMappedToControlId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlTests: async (controlId: string, page?: number, size?: number, sortBy?: ProjectTestSorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, exactMatch?: boolean, testType?: ProjectTestType | null, notMappedToControlId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('getControlTests', 'controlId', controlId)
            const localVarPath = `/controls/{control_id}/tests`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (nameOrUniqueCode !== undefined) {
                localVarQueryParameter['name_or_unique_code'] = nameOrUniqueCode;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            if (testType !== undefined) {
                localVarQueryParameter['test_type'] = testType;
            }

            if (notMappedToControlId !== undefined) {
                localVarQueryParameter['not_mapped_to_control_id'] = notMappedToControlId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query Controls
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ControlsSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [assignedToId] 
         * @param {string | null} [frameworkCode] 
         * @param {string | null} [name] 
         * @param {ControlStatus | null} [status] 
         * @param {boolean | null} [assessed] 
         * @param {boolean} [exactMatch] 
         * @param {Array<string> | null} [policyIds] Filter by policy IDs.
         * @param {Array<string> | null} [projectIds] Filter by project IDs.
         * @param {Array<string> | null} [tags] Filter by tag, as name&#x3D;value
         * @param {boolean | null} [hasEvidence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryControls: async (page?: number, size?: number, sortBy?: ControlsSorting | null, descending?: boolean | null, assignedToId?: string | null, frameworkCode?: string | null, name?: string | null, status?: ControlStatus | null, assessed?: boolean | null, exactMatch?: boolean, policyIds?: Array<string> | null, projectIds?: Array<string> | null, tags?: Array<string> | null, hasEvidence?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/controls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (assignedToId !== undefined) {
                localVarQueryParameter['assigned_to_id'] = assignedToId;
            }

            if (frameworkCode !== undefined) {
                localVarQueryParameter['framework_code'] = frameworkCode;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (assessed !== undefined) {
                localVarQueryParameter['assessed'] = assessed;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            if (policyIds) {
                localVarQueryParameter['policy_ids'] = policyIds;
            }

            if (projectIds) {
                localVarQueryParameter['project_ids'] = projectIds;
            }

            if (tags) {
                localVarQueryParameter['tags'] = tags;
            }

            if (hasEvidence !== undefined) {
                localVarQueryParameter['has_evidence'] = hasEvidence;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List controls with the frameworks, requirements, tags and latest assessment a list view renders.
         * @summary Query Controls Expanded
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ControlsSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [assignedToId] 
         * @param {string | null} [frameworkCode] 
         * @param {string | null} [name] 
         * @param {ControlStatus | null} [status] 
         * @param {boolean | null} [assessed] 
         * @param {boolean} [exactMatch] 
         * @param {Array<string> | null} [policyIds] Filter by policy IDs.
         * @param {Array<string> | null} [projectIds] Filter by project IDs.
         * @param {Array<string> | null} [tags] Filter by tag, as name&#x3D;value
         * @param {boolean | null} [hasEvidence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryControlsExpanded: async (page?: number, size?: number, sortBy?: ControlsSorting | null, descending?: boolean | null, assignedToId?: string | null, frameworkCode?: string | null, name?: string | null, status?: ControlStatus | null, assessed?: boolean | null, exactMatch?: boolean, policyIds?: Array<string> | null, projectIds?: Array<string> | null, tags?: Array<string> | null, hasEvidence?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/controls/expanded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (assignedToId !== undefined) {
                localVarQueryParameter['assigned_to_id'] = assignedToId;
            }

            if (frameworkCode !== undefined) {
                localVarQueryParameter['framework_code'] = frameworkCode;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (assessed !== undefined) {
                localVarQueryParameter['assessed'] = assessed;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            if (policyIds) {
                localVarQueryParameter['policy_ids'] = policyIds;
            }

            if (projectIds) {
                localVarQueryParameter['project_ids'] = projectIds;
            }

            if (tags) {
                localVarQueryParameter['tags'] = tags;
            }

            if (hasEvidence !== undefined) {
                localVarQueryParameter['has_evidence'] = hasEvidence;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a policy association from a control.
         * @summary Remove Control Policy
         * @param {string} controlId 
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeControlPolicy: async (controlId: string, policyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('removeControlPolicy', 'controlId', controlId)
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('removeControlPolicy', 'policyId', policyId)
            const localVarPath = `/controls/{control_id}/policies/{policy_id}`
                .replace('{control_id}', encodeURIComponent(String(controlId)))
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Detach a test from a control.
         * @summary Remove Control Test
         * @param {string} testId 
         * @param {string} controlId 
         * @param {ProjectTestType} testType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeControlTest: async (testId: string, controlId: string, testType: ProjectTestType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('removeControlTest', 'testId', testId)
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('removeControlTest', 'controlId', controlId)
            // verify required parameter 'testType' is not null or undefined
            assertParamExists('removeControlTest', 'testType', testType)
            const localVarPath = `/controls/{control_id}/tests/{test_id}`
                .replace('{test_id}', encodeURIComponent(String(testId)))
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (testType !== undefined) {
                localVarQueryParameter['test_type'] = testType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update multiple components for a control.
         * @summary Update Control Components
         * @param {string} controlId 
         * @param {UpdateComponentsRequest} updateComponentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateControlComponents: async (controlId: string, updateComponentsRequest: UpdateComponentsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('updateControlComponents', 'controlId', controlId)
            // verify required parameter 'updateComponentsRequest' is not null or undefined
            assertParamExists('updateControlComponents', 'updateComponentsRequest', updateComponentsRequest)
            const localVarPath = `/controls/{control_id}/components`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateComponentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Control Ownership
         * @param {string} controlId 
         * @param {UpdateControlOwnershipRequest} updateControlOwnershipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateControlOwnership: async (controlId: string, updateControlOwnershipRequest: UpdateControlOwnershipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('updateControlOwnership', 'controlId', controlId)
            // verify required parameter 'updateControlOwnershipRequest' is not null or undefined
            assertParamExists('updateControlOwnership', 'updateControlOwnershipRequest', updateControlOwnershipRequest)
            const localVarPath = `/controls/{control_id}/owner`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateControlOwnershipRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Control Status
         * @param {string} controlId 
         * @param {UpdateControlStatusRequest} updateControlStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateControlStatus: async (controlId: string, updateControlStatusRequest: UpdateControlStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('updateControlStatus', 'controlId', controlId)
            // verify required parameter 'updateControlStatusRequest' is not null or undefined
            assertParamExists('updateControlStatus', 'updateControlStatusRequest', updateControlStatusRequest)
            const localVarPath = `/controls/{control_id}/status`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateControlStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ControlApi - functional programming interface
 */
export const ControlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ControlApiAxiosParamCreator(configuration)
    return {
        /**
         * Associate a published policy with a control.
         * @summary Associate Control Policy
         * @param {string} controlId 
         * @param {AssociateControlPolicy} associateControlPolicy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async associateControlPolicy(controlId: string, associateControlPolicy: AssociateControlPolicy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Policy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.associateControlPolicy(controlId, associateControlPolicy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.associateControlPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Attach a test — agent or metric — to a control.
         * @summary Associate Control Test
         * @param {string} controlId 
         * @param {AssociateControlTest} associateControlTest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async associateControlTest(controlId: string, associateControlTest: AssociateControlTest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.associateControlTest(controlId, associateControlTest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.associateControlTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Controls Comments
         * @param {string} controlId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createControlsComments(controlId: string, addCommentRequest: AddCommentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Comment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createControlsComments(controlId, addCommentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.createControlsComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Control
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControl(controlId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Control>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControl(controlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.getControl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Control Comments
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControlComments(controlId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Comment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControlComments(controlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.getControlComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all components for a control.
         * @summary Get Control Components
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControlComponents(controlId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Component>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControlComponents(controlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.getControlComponents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all evidence metadata for a control, with each document\'s processing state.
         * @summary Get Control Evidences
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControlEvidences(controlId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EvidenceMetadata>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControlEvidences(controlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.getControlEvidences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Control Logs
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControlLogs(controlId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Log>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControlLogs(controlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.getControlLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get mapped frameworks for a control.
         * @summary Get Control Mapped Frameworks
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControlMappedFrameworks(controlId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Framework>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControlMappedFrameworks(controlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.getControlMappedFrameworks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get mapped requirements for a control.
         * @summary Get Control Mapped Requirements
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControlMappedRequirements(controlId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Requirement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControlMappedRequirements(controlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.getControlMappedRequirements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get policies associated with a control (paginated; sort/filter like GET /policies).
         * @summary Get Control Policies
         * @param {string} controlId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PolicySorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControlPolicies(controlId: string, page?: number, size?: number, sortBy?: PolicySorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControlPolicies(controlId, page, size, sortBy, descending, nameOrUniqueCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.getControlPolicies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Control Tags
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControlTags(controlId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Tag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControlTags(controlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.getControlTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the tests attached to this control, agent and metric together.
         * @summary Get Control Tests
         * @param {string} controlId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ProjectTestSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {boolean} [exactMatch] 
         * @param {ProjectTestType | null} [testType] 
         * @param {string | null} [notMappedToControlId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControlTests(controlId: string, page?: number, size?: number, sortBy?: ProjectTestSorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, exactMatch?: boolean, testType?: ProjectTestType | null, notMappedToControlId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectTestPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControlTests(controlId, page, size, sortBy, descending, nameOrUniqueCode, exactMatch, testType, notMappedToControlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.getControlTests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Query Controls
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ControlsSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [assignedToId] 
         * @param {string | null} [frameworkCode] 
         * @param {string | null} [name] 
         * @param {ControlStatus | null} [status] 
         * @param {boolean | null} [assessed] 
         * @param {boolean} [exactMatch] 
         * @param {Array<string> | null} [policyIds] Filter by policy IDs.
         * @param {Array<string> | null} [projectIds] Filter by project IDs.
         * @param {Array<string> | null} [tags] Filter by tag, as name&#x3D;value
         * @param {boolean | null} [hasEvidence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryControls(page?: number, size?: number, sortBy?: ControlsSorting | null, descending?: boolean | null, assignedToId?: string | null, frameworkCode?: string | null, name?: string | null, status?: ControlStatus | null, assessed?: boolean | null, exactMatch?: boolean, policyIds?: Array<string> | null, projectIds?: Array<string> | null, tags?: Array<string> | null, hasEvidence?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryControls(page, size, sortBy, descending, assignedToId, frameworkCode, name, status, assessed, exactMatch, policyIds, projectIds, tags, hasEvidence, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.queryControls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List controls with the frameworks, requirements, tags and latest assessment a list view renders.
         * @summary Query Controls Expanded
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ControlsSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [assignedToId] 
         * @param {string | null} [frameworkCode] 
         * @param {string | null} [name] 
         * @param {ControlStatus | null} [status] 
         * @param {boolean | null} [assessed] 
         * @param {boolean} [exactMatch] 
         * @param {Array<string> | null} [policyIds] Filter by policy IDs.
         * @param {Array<string> | null} [projectIds] Filter by project IDs.
         * @param {Array<string> | null} [tags] Filter by tag, as name&#x3D;value
         * @param {boolean | null} [hasEvidence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryControlsExpanded(page?: number, size?: number, sortBy?: ControlsSorting | null, descending?: boolean | null, assignedToId?: string | null, frameworkCode?: string | null, name?: string | null, status?: ControlStatus | null, assessed?: boolean | null, exactMatch?: boolean, policyIds?: Array<string> | null, projectIds?: Array<string> | null, tags?: Array<string> | null, hasEvidence?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlExpandedPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryControlsExpanded(page, size, sortBy, descending, assignedToId, frameworkCode, name, status, assessed, exactMatch, policyIds, projectIds, tags, hasEvidence, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.queryControlsExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a policy association from a control.
         * @summary Remove Control Policy
         * @param {string} controlId 
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeControlPolicy(controlId: string, policyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeControlPolicy(controlId, policyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.removeControlPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Detach a test from a control.
         * @summary Remove Control Test
         * @param {string} testId 
         * @param {string} controlId 
         * @param {ProjectTestType} testType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeControlTest(testId: string, controlId: string, testType: ProjectTestType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeControlTest(testId, controlId, testType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.removeControlTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update multiple components for a control.
         * @summary Update Control Components
         * @param {string} controlId 
         * @param {UpdateComponentsRequest} updateComponentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateControlComponents(controlId: string, updateComponentsRequest: UpdateComponentsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Component>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateControlComponents(controlId, updateComponentsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.updateControlComponents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Control Ownership
         * @param {string} controlId 
         * @param {UpdateControlOwnershipRequest} updateControlOwnershipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateControlOwnership(controlId: string, updateControlOwnershipRequest: UpdateControlOwnershipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Control>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateControlOwnership(controlId, updateControlOwnershipRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.updateControlOwnership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Control Status
         * @param {string} controlId 
         * @param {UpdateControlStatusRequest} updateControlStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateControlStatus(controlId: string, updateControlStatusRequest: UpdateControlStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Control>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateControlStatus(controlId, updateControlStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlApi.updateControlStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ControlApi - factory interface
 */
export const ControlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ControlApiFp(configuration)
    return {
        /**
         * Associate a published policy with a control.
         * @summary Associate Control Policy
         * @param {ControlApiAssociateControlPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateControlPolicy(requestParameters: ControlApiAssociateControlPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Policy> {
            return localVarFp.associateControlPolicy(requestParameters.controlId, requestParameters.associateControlPolicy, options).then((request) => request(axios, basePath));
        },
        /**
         * Attach a test — agent or metric — to a control.
         * @summary Associate Control Test
         * @param {ControlApiAssociateControlTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateControlTest(requestParameters: ControlApiAssociateControlTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.associateControlTest(requestParameters.controlId, requestParameters.associateControlTest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Controls Comments
         * @param {ControlApiCreateControlsCommentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createControlsComments(requestParameters: ControlApiCreateControlsCommentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Comment> {
            return localVarFp.createControlsComments(requestParameters.controlId, requestParameters.addCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Control
         * @param {ControlApiGetControlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControl(requestParameters: ControlApiGetControlRequest, options?: RawAxiosRequestConfig): AxiosPromise<Control> {
            return localVarFp.getControl(requestParameters.controlId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Control Comments
         * @param {ControlApiGetControlCommentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlComments(requestParameters: ControlApiGetControlCommentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Comment>> {
            return localVarFp.getControlComments(requestParameters.controlId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all components for a control.
         * @summary Get Control Components
         * @param {ControlApiGetControlComponentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlComponents(requestParameters: ControlApiGetControlComponentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Component>> {
            return localVarFp.getControlComponents(requestParameters.controlId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all evidence metadata for a control, with each document\'s processing state.
         * @summary Get Control Evidences
         * @param {ControlApiGetControlEvidencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlEvidences(requestParameters: ControlApiGetControlEvidencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EvidenceMetadata>> {
            return localVarFp.getControlEvidences(requestParameters.controlId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Control Logs
         * @param {ControlApiGetControlLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlLogs(requestParameters: ControlApiGetControlLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Log>> {
            return localVarFp.getControlLogs(requestParameters.controlId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get mapped frameworks for a control.
         * @summary Get Control Mapped Frameworks
         * @param {ControlApiGetControlMappedFrameworksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlMappedFrameworks(requestParameters: ControlApiGetControlMappedFrameworksRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Framework>> {
            return localVarFp.getControlMappedFrameworks(requestParameters.controlId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get mapped requirements for a control.
         * @summary Get Control Mapped Requirements
         * @param {ControlApiGetControlMappedRequirementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlMappedRequirements(requestParameters: ControlApiGetControlMappedRequirementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Requirement>> {
            return localVarFp.getControlMappedRequirements(requestParameters.controlId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get policies associated with a control (paginated; sort/filter like GET /policies).
         * @summary Get Control Policies
         * @param {ControlApiGetControlPoliciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlPolicies(requestParameters: ControlApiGetControlPoliciesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyPaginated> {
            return localVarFp.getControlPolicies(requestParameters.controlId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Control Tags
         * @param {ControlApiGetControlTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlTags(requestParameters: ControlApiGetControlTagsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Tag>> {
            return localVarFp.getControlTags(requestParameters.controlId, options).then((request) => request(axios, basePath));
        },
        /**
         * List the tests attached to this control, agent and metric together.
         * @summary Get Control Tests
         * @param {ControlApiGetControlTestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlTests(requestParameters: ControlApiGetControlTestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectTestPaginated> {
            return localVarFp.getControlTests(requestParameters.controlId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.exactMatch, requestParameters.testType, requestParameters.notMappedToControlId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query Controls
         * @param {ControlApiQueryControlsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryControls(requestParameters: ControlApiQueryControlsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ControlPaginated> {
            return localVarFp.queryControls(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.assignedToId, requestParameters.frameworkCode, requestParameters.name, requestParameters.status, requestParameters.assessed, requestParameters.exactMatch, requestParameters.policyIds, requestParameters.projectIds, requestParameters.tags, requestParameters.hasEvidence, options).then((request) => request(axios, basePath));
        },
        /**
         * List controls with the frameworks, requirements, tags and latest assessment a list view renders.
         * @summary Query Controls Expanded
         * @param {ControlApiQueryControlsExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryControlsExpanded(requestParameters: ControlApiQueryControlsExpandedRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ControlExpandedPaginated> {
            return localVarFp.queryControlsExpanded(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.assignedToId, requestParameters.frameworkCode, requestParameters.name, requestParameters.status, requestParameters.assessed, requestParameters.exactMatch, requestParameters.policyIds, requestParameters.projectIds, requestParameters.tags, requestParameters.hasEvidence, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a policy association from a control.
         * @summary Remove Control Policy
         * @param {ControlApiRemoveControlPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeControlPolicy(requestParameters: ControlApiRemoveControlPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeControlPolicy(requestParameters.controlId, requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Detach a test from a control.
         * @summary Remove Control Test
         * @param {ControlApiRemoveControlTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeControlTest(requestParameters: ControlApiRemoveControlTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeControlTest(requestParameters.testId, requestParameters.controlId, requestParameters.testType, options).then((request) => request(axios, basePath));
        },
        /**
         * Update multiple components for a control.
         * @summary Update Control Components
         * @param {ControlApiUpdateControlComponentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateControlComponents(requestParameters: ControlApiUpdateControlComponentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Component>> {
            return localVarFp.updateControlComponents(requestParameters.controlId, requestParameters.updateComponentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Control Ownership
         * @param {ControlApiUpdateControlOwnershipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateControlOwnership(requestParameters: ControlApiUpdateControlOwnershipRequest, options?: RawAxiosRequestConfig): AxiosPromise<Control> {
            return localVarFp.updateControlOwnership(requestParameters.controlId, requestParameters.updateControlOwnershipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Control Status
         * @param {ControlApiUpdateControlStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateControlStatus(requestParameters: ControlApiUpdateControlStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<Control> {
            return localVarFp.updateControlStatus(requestParameters.controlId, requestParameters.updateControlStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for associateControlPolicy operation in ControlApi.
 */
export interface ControlApiAssociateControlPolicyRequest {
    readonly controlId: string

    readonly associateControlPolicy: AssociateControlPolicy
}

/**
 * Request parameters for associateControlTest operation in ControlApi.
 */
export interface ControlApiAssociateControlTestRequest {
    readonly controlId: string

    readonly associateControlTest: AssociateControlTest
}

/**
 * Request parameters for createControlsComments operation in ControlApi.
 */
export interface ControlApiCreateControlsCommentsRequest {
    readonly controlId: string

    readonly addCommentRequest: AddCommentRequest
}

/**
 * Request parameters for getControl operation in ControlApi.
 */
export interface ControlApiGetControlRequest {
    readonly controlId: string
}

/**
 * Request parameters for getControlComments operation in ControlApi.
 */
export interface ControlApiGetControlCommentsRequest {
    readonly controlId: string
}

/**
 * Request parameters for getControlComponents operation in ControlApi.
 */
export interface ControlApiGetControlComponentsRequest {
    readonly controlId: string
}

/**
 * Request parameters for getControlEvidences operation in ControlApi.
 */
export interface ControlApiGetControlEvidencesRequest {
    readonly controlId: string
}

/**
 * Request parameters for getControlLogs operation in ControlApi.
 */
export interface ControlApiGetControlLogsRequest {
    readonly controlId: string
}

/**
 * Request parameters for getControlMappedFrameworks operation in ControlApi.
 */
export interface ControlApiGetControlMappedFrameworksRequest {
    readonly controlId: string
}

/**
 * Request parameters for getControlMappedRequirements operation in ControlApi.
 */
export interface ControlApiGetControlMappedRequirementsRequest {
    readonly controlId: string
}

/**
 * Request parameters for getControlPolicies operation in ControlApi.
 */
export interface ControlApiGetControlPoliciesRequest {
    readonly controlId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: PolicySorting | null

    readonly descending?: boolean | null

    readonly nameOrUniqueCode?: string | null
}

/**
 * Request parameters for getControlTags operation in ControlApi.
 */
export interface ControlApiGetControlTagsRequest {
    readonly controlId: string
}

/**
 * Request parameters for getControlTests operation in ControlApi.
 */
export interface ControlApiGetControlTestsRequest {
    readonly controlId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: ProjectTestSorting | null

    readonly descending?: boolean | null

    readonly nameOrUniqueCode?: string | null

    readonly exactMatch?: boolean

    readonly testType?: ProjectTestType | null

    readonly notMappedToControlId?: string | null
}

/**
 * Request parameters for queryControls operation in ControlApi.
 */
export interface ControlApiQueryControlsRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: ControlsSorting | null

    readonly descending?: boolean | null

    readonly assignedToId?: string | null

    readonly frameworkCode?: string | null

    readonly name?: string | null

    readonly status?: ControlStatus | null

    readonly assessed?: boolean | null

    readonly exactMatch?: boolean

    /**
     * Filter by policy IDs.
     */
    readonly policyIds?: Array<string> | null

    /**
     * Filter by project IDs.
     */
    readonly projectIds?: Array<string> | null

    /**
     * Filter by tag, as name&#x3D;value
     */
    readonly tags?: Array<string> | null

    readonly hasEvidence?: boolean | null
}

/**
 * Request parameters for queryControlsExpanded operation in ControlApi.
 */
export interface ControlApiQueryControlsExpandedRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: ControlsSorting | null

    readonly descending?: boolean | null

    readonly assignedToId?: string | null

    readonly frameworkCode?: string | null

    readonly name?: string | null

    readonly status?: ControlStatus | null

    readonly assessed?: boolean | null

    readonly exactMatch?: boolean

    /**
     * Filter by policy IDs.
     */
    readonly policyIds?: Array<string> | null

    /**
     * Filter by project IDs.
     */
    readonly projectIds?: Array<string> | null

    /**
     * Filter by tag, as name&#x3D;value
     */
    readonly tags?: Array<string> | null

    readonly hasEvidence?: boolean | null
}

/**
 * Request parameters for removeControlPolicy operation in ControlApi.
 */
export interface ControlApiRemoveControlPolicyRequest {
    readonly controlId: string

    readonly policyId: string
}

/**
 * Request parameters for removeControlTest operation in ControlApi.
 */
export interface ControlApiRemoveControlTestRequest {
    readonly testId: string

    readonly controlId: string

    readonly testType: ProjectTestType
}

/**
 * Request parameters for updateControlComponents operation in ControlApi.
 */
export interface ControlApiUpdateControlComponentsRequest {
    readonly controlId: string

    readonly updateComponentsRequest: UpdateComponentsRequest
}

/**
 * Request parameters for updateControlOwnership operation in ControlApi.
 */
export interface ControlApiUpdateControlOwnershipRequest {
    readonly controlId: string

    readonly updateControlOwnershipRequest: UpdateControlOwnershipRequest
}

/**
 * Request parameters for updateControlStatus operation in ControlApi.
 */
export interface ControlApiUpdateControlStatusRequest {
    readonly controlId: string

    readonly updateControlStatusRequest: UpdateControlStatusRequest
}

/**
 * ControlApi - object-oriented interface
 */
export class ControlApi extends BaseAPI {
    /**
     * Associate a published policy with a control.
     * @summary Associate Control Policy
     * @param {ControlApiAssociateControlPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public associateControlPolicy(requestParameters: ControlApiAssociateControlPolicyRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).associateControlPolicy(requestParameters.controlId, requestParameters.associateControlPolicy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Attach a test — agent or metric — to a control.
     * @summary Associate Control Test
     * @param {ControlApiAssociateControlTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public associateControlTest(requestParameters: ControlApiAssociateControlTestRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).associateControlTest(requestParameters.controlId, requestParameters.associateControlTest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Controls Comments
     * @param {ControlApiCreateControlsCommentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createControlsComments(requestParameters: ControlApiCreateControlsCommentsRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).createControlsComments(requestParameters.controlId, requestParameters.addCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Control
     * @param {ControlApiGetControlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getControl(requestParameters: ControlApiGetControlRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).getControl(requestParameters.controlId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Control Comments
     * @param {ControlApiGetControlCommentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getControlComments(requestParameters: ControlApiGetControlCommentsRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).getControlComments(requestParameters.controlId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all components for a control.
     * @summary Get Control Components
     * @param {ControlApiGetControlComponentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getControlComponents(requestParameters: ControlApiGetControlComponentsRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).getControlComponents(requestParameters.controlId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all evidence metadata for a control, with each document\'s processing state.
     * @summary Get Control Evidences
     * @param {ControlApiGetControlEvidencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getControlEvidences(requestParameters: ControlApiGetControlEvidencesRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).getControlEvidences(requestParameters.controlId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Control Logs
     * @param {ControlApiGetControlLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getControlLogs(requestParameters: ControlApiGetControlLogsRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).getControlLogs(requestParameters.controlId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get mapped frameworks for a control.
     * @summary Get Control Mapped Frameworks
     * @param {ControlApiGetControlMappedFrameworksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getControlMappedFrameworks(requestParameters: ControlApiGetControlMappedFrameworksRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).getControlMappedFrameworks(requestParameters.controlId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get mapped requirements for a control.
     * @summary Get Control Mapped Requirements
     * @param {ControlApiGetControlMappedRequirementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getControlMappedRequirements(requestParameters: ControlApiGetControlMappedRequirementsRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).getControlMappedRequirements(requestParameters.controlId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get policies associated with a control (paginated; sort/filter like GET /policies).
     * @summary Get Control Policies
     * @param {ControlApiGetControlPoliciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getControlPolicies(requestParameters: ControlApiGetControlPoliciesRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).getControlPolicies(requestParameters.controlId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Control Tags
     * @param {ControlApiGetControlTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getControlTags(requestParameters: ControlApiGetControlTagsRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).getControlTags(requestParameters.controlId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the tests attached to this control, agent and metric together.
     * @summary Get Control Tests
     * @param {ControlApiGetControlTestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getControlTests(requestParameters: ControlApiGetControlTestsRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).getControlTests(requestParameters.controlId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.exactMatch, requestParameters.testType, requestParameters.notMappedToControlId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query Controls
     * @param {ControlApiQueryControlsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryControls(requestParameters: ControlApiQueryControlsRequest = {}, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).queryControls(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.assignedToId, requestParameters.frameworkCode, requestParameters.name, requestParameters.status, requestParameters.assessed, requestParameters.exactMatch, requestParameters.policyIds, requestParameters.projectIds, requestParameters.tags, requestParameters.hasEvidence, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List controls with the frameworks, requirements, tags and latest assessment a list view renders.
     * @summary Query Controls Expanded
     * @param {ControlApiQueryControlsExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryControlsExpanded(requestParameters: ControlApiQueryControlsExpandedRequest = {}, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).queryControlsExpanded(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.assignedToId, requestParameters.frameworkCode, requestParameters.name, requestParameters.status, requestParameters.assessed, requestParameters.exactMatch, requestParameters.policyIds, requestParameters.projectIds, requestParameters.tags, requestParameters.hasEvidence, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a policy association from a control.
     * @summary Remove Control Policy
     * @param {ControlApiRemoveControlPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeControlPolicy(requestParameters: ControlApiRemoveControlPolicyRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).removeControlPolicy(requestParameters.controlId, requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Detach a test from a control.
     * @summary Remove Control Test
     * @param {ControlApiRemoveControlTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeControlTest(requestParameters: ControlApiRemoveControlTestRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).removeControlTest(requestParameters.testId, requestParameters.controlId, requestParameters.testType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update multiple components for a control.
     * @summary Update Control Components
     * @param {ControlApiUpdateControlComponentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateControlComponents(requestParameters: ControlApiUpdateControlComponentsRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).updateControlComponents(requestParameters.controlId, requestParameters.updateComponentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Control Ownership
     * @param {ControlApiUpdateControlOwnershipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateControlOwnership(requestParameters: ControlApiUpdateControlOwnershipRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).updateControlOwnership(requestParameters.controlId, requestParameters.updateControlOwnershipRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Control Status
     * @param {ControlApiUpdateControlStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateControlStatus(requestParameters: ControlApiUpdateControlStatusRequest, options?: RawAxiosRequestConfig) {
        return ControlApiFp(this.configuration).updateControlStatus(requestParameters.controlId, requestParameters.updateControlStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

